module.exports = __webpack_public_path__ + "static/media/dashboard_screenshot.5acde306.png";